import { Button, Form, Input, Radio, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { useSelector } from "react-redux";
import { useForm } from "antd/lib/form/Form";
import { useLocation, useHistory } from "react-router-dom";

import { Locale } from "../../../utils";
import {
  handleMutationError,
  showNotificationWithIcon,
} from "../../../utils/helpers/helpers";
import { getUserInfo } from "../../../utils/redux/reducers/User";
import { BreadCrumb } from "../../../components/main/LayoutComponents";

import "./AddOrEditEmployee.scss";
import { create, getOne, update } from "../../../utils/http/dataProvider";
import ImageUpload from "../../../components/media/ImageUpload";
import TranslateBtn from "../../../components/product/TranslateBtn";
import SlateRichTextEditor from "../../../components/editor/SlateRichTextEditor";
import UserSelector from "../../../components/main/UserSelector";

const i18n = Locale.getInstance();
let counter = 0;
const AddOrEditEmployee = () => {
  const user = useSelector((state) => getUserInfo(state));
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const [employeeForm] = useForm();
  const history = useHistory();
  const location = useLocation();

  const id = location?.state?.id;
  counter += 1;

  const { data, isLoading } = useQuery(
    ["bd-employees-detail", user.token],
    () => getOne("bd/employees", { id, token: user.token }),
    {
      enabled: !!id,
    }
  );

  useEffect(() => {
    if (data && id === data?.id) {
      const values = {
        name: data.name,
        mobile: data.mobile,
        avatar: data?.avatar_media ? [data?.avatar_media] : [],
      };

      employeeForm.setFieldsValue(values);
    }
    if (!id) {
      employeeForm.setFieldsValue({
        mobile: "",
        name: "",
        avatar: [],
      });
    }
  }, [data]);

  const addEmployeeMutation = useMutation(create, {
    onSuccess: () => {
      queryClient.invalidateQueries("bd-employees");
      showNotificationWithIcon(i18n.t("media.saveFinished"), "success");
      setLoading(false);
      history.goBack();
    },
    onError: (error) => {
      handleMutationError(error);
      setLoading(false);
    },
  });

  const updateEmployeeMutation = useMutation(update, {
    onSuccess: () => {
      queryClient.invalidateQueries("bd-employees");
      showNotificationWithIcon(i18n.t("media.saveFinished"), "success");
      setLoading(false);
      history.goBack();
    },
    onError: (error) => {
      handleMutationError(error);
      setLoading(false);
    },
  });

  const onFinish = (values) => {
    console.log("🚀 ~ onFinish ~ values:", values)
    if (values.avatar && values.avatar.length > 0) {
      values["avatar"] = values["avatar"][0]["file_path"];
    }
    setLoading(true);
    const params = {
      data: values,
      token: user.token,
    };

    if (id) {
      updateEmployeeMutation.mutate({
        resource: "bd/employees",
        params: { ...params, id },
      });
    } else {
      addEmployeeMutation.mutate({ resource: "bd/employees", params });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
    showNotificationWithIcon(errorInfo);
  };

  const breadCrumbData = [
    {
      href: "/main/bd/employees",
      title: i18n.t("bd.employee.title"),
    },
    {
      title: id ? i18n.t("bd.employee.edit") : i18n.t("bd.employee.add"),
    },
  ];

  if (isLoading) {
    return <Spin spinning={isLoading} />;
  }
  return (
    <>
      <BreadCrumb data={breadCrumbData} />
      <Spin spinning={loading}>
        <Form
          form={employeeForm}
          className="employee-form"
          name="basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 20 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue, setFieldsValue }) => (
              <Form.Item
                shouldUpdate
                name="name"
                label={i18n.t("users.name")}
                initialValue={data?.name}
                rules={[
                  {
                    required: true,
                    message: i18n.t("productEdit.standardRequired"),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            )}
          </Form.Item>

          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue, setFieldsValue }) => (
              <Form.Item name="avatar" label={i18n.t("users.avatar")}>
                <ImageUpload
                  images={getFieldValue("avatar")}
                  setSelectedImages={(image) => {
                    setFieldsValue({
                      avatar: image,
                    });
                  }}
                />
              </Form.Item>
            )}
          </Form.Item>
          <Form.Item
            name="mobile"
            label={i18n.t("common.mobile")}
            initialValue={data?.mobile}
            shouldUpdate
            rules={[
              {
                required: true,
                message: i18n.t("productEdit.standardRequired"),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="password"
            label={i18n.t("login.password")}
            type="password"
            shouldUpdate
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="status"
            label={i18n.t("course.status")}
            initialValue={1}
          >
            <Radio.Group>
              <Radio defaultChecked={true} value={1}>
                {i18n.t("shows.status.active")}
              </Radio>
              <Radio value={0}>{i18n.t("shows.status.inactive")}</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item className="submit">
            <Button type="primary" htmlType="submit">
              {i18n.t("productEdit.saveAndBack")}
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </>
  );
};

export default AddOrEditEmployee;
